export interface PageResponse<T> {
  /**
   * Page number
   */
  number: number

  /**
   * Page size
   */
  size: number

  /**
   * Total number of elements available
   */
  total: number

  /**
   * Items that were found
   */
  items: T[]
}

export function emptyPageResponse<T>(): PageResponse<T> {
  return {
    items: [],
    number: 1,
    size: 0,
    total: 0,
  }
}
